import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';

const ROLES = {
  ADMIN: 'ADMIN',
  DATA_MANAGER: 'DATA_MANAGER',
  LOGISTICS_COORDINATOR: 'LOGISTICS_COORDINATOR',
  AREA_COORDINATOR: 'AREA_COORDINATOR',
  CLIENT: 'CLIENT',
};

const PERMISSIONS = {
  CREATE_AMENDMENT: 'feedback_add',
  EDIT_AMENDMENT: 'feedback_change',
  DELETE_AMENDMENT: 'feedback_delete',
  VIEW_AMENDMENT: 'feedback_view',
  APPROVE_AMENDMENT: 'feedback_approve'
};

const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_AMENDMENT,
    PERMISSIONS.EDIT_AMENDMENT,
    PERMISSIONS.DELETE_AMENDMENT,
    PERMISSIONS.VIEW_AMENDMENT,
    PERMISSIONS.APPROVE_AMENDMENT
  ],
  [ROLES.DATA_MANAGER]: [
    PERMISSIONS.CREATE_AMENDMENT,
    PERMISSIONS.EDIT_AMENDMENT,
    PERMISSIONS.VIEW_AMENDMENT,
    PERMISSIONS.APPROVE_AMENDMENT
  ],
  [ROLES.AREA_COORDINATOR]: [
    PERMISSIONS.VIEW_AMENDMENT,
    PERMISSIONS.APPROVE_AMENDMENT
  ],
  [ROLES.CLIENT]: [
    PERMISSIONS.VIEW_AMENDMENT,
    PERMISSIONS.CREATE_AMENDMENT
  ]
};

const useAmendmentPermissions = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasPermission = (permission) => {
    if (!user?.role?.name) return false;
    return ROLE_PERMISSIONS[user.role.name]?.includes(permission) || false;
  };

  return {
    loading,
    error,
    canView: hasPermission(PERMISSIONS.VIEW_AMENDMENT),
    canAdd: hasPermission(PERMISSIONS.CREATE_AMENDMENT),
    canEdit: hasPermission(PERMISSIONS.EDIT_AMENDMENT),
    canDelete: hasPermission(PERMISSIONS.DELETE_AMENDMENT),
    canApprove: hasPermission(PERMISSIONS.APPROVE_AMENDMENT),
    isAdmin: user?.role?.name === ROLES.ADMIN,
    isDataManager: user?.role?.name === ROLES.DATA_MANAGER
  };
};

export default useAmendmentPermissions;
